import Icon from "@material-ui/icons/Person";
import AcademicTermCreate from "./CcaAcademicTermCreate";
import AcademicTermEdit from "./CcaAcademicTermEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaAcademicTerms",
  edit: AcademicTermEdit,
  create: AcademicTermCreate,
  icon: Icon,
};
